import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import {currentSiteName} from "../../../service/SiteService";

class FAQ extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Frequently asked questions</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h4>
                                    What is {currentSiteName}?
                                </h4>
                                <p>
                                    {currentSiteName} is a chat bot - specifically, a bot user that you can
                                    instruct to perform actions in your build and deployment systems,
                                    like <Link to="/docs/bot/build-systems">Jenkins and Rundeck</Link>.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h4>
                                    How does it work?
                                </h4>
                                <p>
                                    Magic. Seriously, though; when you type a command in Slack, like <code>
                                    @cloudMocks deploy services</code>, {currentSiteName} looks
                                    for a matching action that you have defined. If it finds one,
                                    it performs the action and reports the result in your chat. You
                                    can learn more about actions <Link to="/docs/bot/actions">here</Link>.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h4>
                                    Do you have access to my servers?
                                </h4>
                                <p>
                                    {currentSiteName} only has access to the APIs of your build or deployment
                                    systems that you grant to it. Even then, {currentSiteName} can only perform
                                    the actions that the user you provide in
                                    your <Link to="/docs/bot/connections">Connections</Link> has the permission
                                    to execute.
                                </p>
                                <p>
                                    For more details about permissions granted via your build
                                    system's API, check its documentation.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h4>
                                    How can I control who can run certain jobs?
                                </h4>
                                <p>
                                    {currentSiteName} has a powerful Role-based access control (RBAC) security
                                    model that allows you to control which users can perform certain
                                    actions, and on which jobs. For more information, see
                                    the <Link to="/docs/bot/action-security">Action Security</Link> configuration page.
                                </p>
                            </div>

                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/modules/views/docs/bot/FAQ.js